import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from 'react-bootstrap/Modal';
import { decryptFromStoreLoc } from "../helper/localStorage";
import { useDashboard } from "../context/DashboardContext";

function Header({ toggleSidebar }) {

  const location = useLocation();
  const [title, setTitle] = useState("");
  const navigate = useNavigate();
  const { 
    selectedPeriod, 
    setSelectedPeriod, 
    selectedCustomRange, 
    setSelectedCustomRange, 
    customRangeApplied, 
    setCustomRangeApplied 
  } = useDashboard();

  // Clear applied state when custom range dates change
  const handleDateChange = (field, value) => {
    setSelectedCustomRange(range => ({
      ...range,
      [field]: value,
    }));
    // Clear applied state when dates are modified
    if (customRangeApplied) {
      setCustomRangeApplied(false);
    }
  };

  const logOut = () => {
    localStorage.clear();
    window.location.href = "/";
  }

  const baseURL = process.env.REACT_APP_BASE_URL;
  const firstName = decryptFromStoreLoc("firstName");
  const imageURL = decryptFromStoreLoc("imageURL");

  useEffect(() => {
    if (location.pathname === "/profile") {
      setTitle("Profile");
    }
    if (location.pathname === "/dashboard") {
      setTitle("Dashboard");
    }
    if (location.pathname === "/user-management") {
      setTitle("User Management");
    }
    if (location.pathname === "/activity-management") {
      setTitle("Reported Content");
    }
    if (location.pathname === "/marketplace-management") {
      setTitle("Marketplace Management");
    }
    if (location.pathname === "/category-management") {
      setTitle("Category Management");
    }
    // if (location.pathname === "/event-management/edit") {
    //   setTitle("Edit Event Management");
    // }
    if (location.pathname === "/notification-management") {
      setTitle("Notification Management");
    }
    if (location.pathname === "/feedback-support") {
      setTitle("Feedback & Support Module");
    }
    if (location.pathname === "/privacy-policy-admin") {
      setTitle("Privacy Policy");
    }
  }, [location.pathname]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <header className='header-wrapper'>
        <div className='d-flex align-items-center gap-sm-3 gap-2'>
          <div className='toggle-bar d-lg-none' onClick={toggleSidebar}>
            <img src="/images/svg/toggle-bar.svg" alt="icon" />
          </div>
          <h4>{title}</h4>
        </div>
        
        <div className='d-flex align-items-center gap-3 flex-wrap'>
          {location.pathname === "/dashboard" && (
            <>
              <Dropdown>
                <Dropdown.Toggle 
                  variant="success" 
                  id="period-dropdown"
                  className="period-dropdown-toggle"
                >
                   {(() => {
                     switch(selectedPeriod) {
                       case 'all': return "All Time";
                       case 'daily': return "Daily";
                       case 'weekly': return "Weekly";
                       case 'monthly': return "Monthly";
                        case 'custom':
                          return selectedCustomRange && selectedCustomRange.start && selectedCustomRange.end
                            ? `${selectedCustomRange.start} - ${selectedCustomRange.end}`
                            : "Custom Range";
                        default:
                          return "All Time";
                     }
                   })()}
                </Dropdown.Toggle>
                <Dropdown.Menu className="period-dropdown-menu">
                  <Dropdown.Item
                    onClick={() => setSelectedPeriod('all')}
                    active={selectedPeriod === 'all'}
                    className={selectedPeriod === 'all' ? 'selected-period-item' : ''}
                  >
                    All Time
                    {selectedPeriod === 'all' && (
                      <i className="fas fa-check ms-auto"></i>
                    )}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => setSelectedPeriod('daily')}
                    active={selectedPeriod === 'daily'}
                    className={selectedPeriod === 'daily' ? 'selected-period-item' : ''}
                  >
                    Daily
                    {selectedPeriod === 'daily' && (
                      <i className="fas fa-check ms-auto"></i>
                    )}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => setSelectedPeriod('weekly')}
                    active={selectedPeriod === 'weekly'}
                    className={selectedPeriod === 'weekly' ? 'selected-period-item' : ''}
                  >
                    Weekly
                    {selectedPeriod === 'weekly' && (
                      <i className="fas fa-check ms-auto"></i>
                    )}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => setSelectedPeriod('monthly')}
                    active={selectedPeriod === 'monthly'}
                    className={selectedPeriod === 'monthly' ? 'selected-period-item' : ''}
                  >
                    Monthly
                    {selectedPeriod === 'monthly' && (
                      <i className="fas fa-check ms-auto"></i>
                    )}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => setSelectedPeriod('custom')}
                    active={selectedPeriod === 'custom'}
                    className={selectedPeriod === 'custom' ? 'selected-period-item' : ''}
                  >
                    Custom Range
                    {selectedPeriod === 'custom' && (
                      <i className="fas fa-check ms-auto"></i>
                    )}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {/* Custom Range Picker - Display beside dropdown when custom is selected */}
              {selectedPeriod === 'custom' && (
                <div className="d-flex align-items-center gap-2">
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={selectedCustomRange?.start || ''}
                        onChange={e => handleDateChange('start', e.target.value)}
                    style={{ 
                      width: 'auto',
                      minWidth: '140px',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      padding: '6px 10px',
                      fontSize: '13px'
                    }}
                  />
                  <span className="text-muted" style={{ fontSize: '13px' }}>to</span>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={selectedCustomRange?.end || ''}
                        onChange={e => handleDateChange('end', e.target.value)}
                    style={{ 
                      width: 'auto',
                      minWidth: '140px',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      padding: '6px 10px',
                      fontSize: '13px'
                    }}
                  />
                      <button
                        className={`btn btn-sm ${customRangeApplied ? 'btn-success' : 'btn-primary'}`}
                        disabled={!selectedCustomRange.start || !selectedCustomRange.end}
                        onClick={() => {
                          setCustomRangeApplied(true);
                        }}
                    style={{
                      padding: '6px 16px',
                      borderRadius: '6px',
                      fontSize: '13px',
                      fontWeight: '500'
                    }}
                      >
                        {customRangeApplied ? 'Applied' : 'Apply'}
                      </button>
                </div>
              )}
            </>
          )}
          <Dropdown className='user-dropdown'>
            <Dropdown.Toggle id="profile-dropdown" className='d-flex align-items-center text-start gap-2'>
              <img className='user-img' src={imageURL ? baseURL + imageURL : "/images/svg/vector.svg"} alt="user" />
              <div className='d-flex align-items-center gap-xxl-4 gap-3'>
                <div className='d-sm-block d-none'>
                  <h5>Hello, {firstName}</h5>
                  <h6>Admin</h6>
                </div>
                <img src="/images/svg/down-arrow.svg" alt="icon" />
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => { navigate('/profile') }}>
                <img src="/images/svg/profile.svg" alt="icon" />
                Profile
              </Dropdown.Item>
              <Dropdown.Item onClick={handleShow}>
                <img src="/images/svg/logout.svg" alt="icon" />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body className='text-center'>
          <div className='d-flex justify-content-end'>
            <button className='btn-close' onClick={handleClose}></button>
          </div>
          <div className='modal-status-icon bg-light-primary'>
            <img src="/images/svg/logout-modal.svg" alt="img" />
          </div>
          <h5 className='mt-3 mb-4 px-sm-5'>Are you sure you want to logout?</h5>
          <button className='btn btn-primary w-100' onClick={logOut}>Logout</button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Header;
